import exists from 'exists';
import config from 'Config';
import { getOptimalWidthAndHeight } from './dictionary';
type Format = 'jpeg' | '_AUTOFORMAT_';
export type Transformation = 'crop' | 'resize';
type GetUrl = (arg0: {
  url: string;
  format: Format;
  width: 'auto' | string | number;
  height: 'auto' | string | number;
  transform: Transformation;
  gravity?: string;
  quality?: number;
}) => string;
export const getUrl: GetUrl = ({ url, format, width, height, transform, gravity, quality }) => {
  if (typeof url !== 'string') {
    return url;
  }

  function getOptionsPathParameters() {
    /*
     * TODO Remove this with issue #14434
     * Due to webedia and media-server incompatibility we need to replace hostname
     * and avoid multiple redirects. See issue #14141.
     */
    const encodedUrl = encodeURIComponent(
      url.replace('http://viaimage2.viafrance.com', 'http://viaimage3.viafrance.com'),
    );
    const optimizedDimensions = getOptimalWidthAndHeight(width, height);

    if (!config.get('media.apiV2.enabled')) {
      return [
        format,
        optimizedDimensions.width,
        optimizedDimensions.height,
        transform,
        transform === 'crop' ? gravity : null,
        quality,
        encodedUrl,
      ];
    }

    return [
      encodedUrl,
      format,
      optimizedDimensions.width,
      optimizedDimensions.height,
      transform,
      transform === 'crop' ? gravity : null,
      quality,
    ];
  }

  if (!config.get('media.apiV2.enabled')) {
    return [config.get('media.host'), 'image']
      .concat(getOptionsPathParameters())
      .filter(exists)
      .join('/');
  }

  return [config.get('media.host'), 'v2', 'image']
    .concat(getOptionsPathParameters())
    .filter(exists)
    .join('/');
};
